import { ReactElement } from 'react'
import { number, object } from 'yup'
import RestoreIcon from '@mui/icons-material/Restore'
import { Box, MenuItem, Stack, Tooltip } from '@mui/material'
import { Form2, FormIconButton, TextField } from '@ui/forms'

interface Props {
  name: string
  label: string
  /** Shown as the input's end adornment. */
  unit?: string
  tooltip: string
  value: number
  defaultValue: number
  onChange: (value: number) => void
  dataCy: string
}

/**
 * Number input of a load render setting, applied on change, with a reset to its default. Only
 * positive numbers are applied; anything else shows a validation error and keeps the old value.
 */
const LoadRenderNumberField = ({
  name,
  label,
  unit,
  tooltip,
  value,
  defaultValue,
  onChange,
  dataCy,
}: Props): ReactElement => (
  <MenuItem>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 240 }}>
      <Tooltip title={tooltip} placement="left">
        <Box>
          <Form2
            onSubmit={values => onChange(values[name])}
            defaultValues={{ [name]: value }}
            validationSchema={object({ [name]: number().required().positive() })}
            submitOnChange
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Box display="flex" flex={1}>
                <TextField
                  inputLabel={label}
                  name={name}
                  unit={unit}
                  type="number"
                  size="small"
                  sx={{ flex: 1 }}
                  data-cy={dataCy}
                />
              </Box>
              <Tooltip title="Auf Standardwert zurücksetzen" placement="top">
                <Box>
                  <FormIconButton name={name} value={defaultValue}>
                    <RestoreIcon fontSize="small" />
                  </FormIconButton>
                </Box>
              </Tooltip>
            </Stack>
          </Form2>
        </Box>
      </Tooltip>
    </Box>
  </MenuItem>
)

export default LoadRenderNumberField
